import { TagDataLayer } from '@axa-fr-axion/tag';
import { NavigationPath } from 'interfaces';

export const DATA_LAYER_GLOBAL: Omit<TagDataLayer, 'xiti_xtpage'> = {
    page_univers: 'professionnel',
    nom_site: 'devis_pro',
    // INFO: This value will differ depending on the visitor.
    statut_client: 'prospect',
};

export const getProEntNavigationData = (funnel?: string): Record<NavigationPath, TagDataLayer | null> => ({
    RecommandationHome: {
        xiti_xtpage: 'devis_pro::etape_1_besoin::orientation_besoin',
        nom_etape: 'etape_1_besoin/orientation_besoin',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    Catalog: {
        xiti_xtpage: 'devis_pro::etape_1_besoin::selection_produits',
        nom_etape: 'etape_1_besoin/selection_produits',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    Company: {
        xiti_xtpage: 'devis_pro::etape_2_entreprise::siret',
        nom_etape: 'etape_2_entreprise/siret',
        sollicitation: 0,
        num_etape: 2,
        page_erreur: 0,
    },
    EconomicSector: {
        xiti_xtpage: 'devis_pro::etape_2_entreprise::secteur_activite',
        nom_etape: 'etape_2_entreprise/secteur_activite',
        sollicitation: 0,
        num_etape: 2,
        page_erreur: 0,
    },
    LegalStatus: {
        xiti_xtpage: 'devis_pro::etape_2_entreprise::forme_juridique',
        nom_etape: 'etape_2_entreprise/forme_juridique',
        sollicitation: 0,
        num_etape: 2,
        page_erreur: 0,
    },
    NumberOfEmployees: {
        xiti_xtpage: 'devis_pro::etape_2_entreprise::nombre_salaries',
        nom_etape: 'etape_2_entreprise/nombre_salaries',
        sollicitation: 0,
        num_etape: 2,
        page_erreur: 0,
    },
    Income: {
        xiti_xtpage: 'devis_pro::etape_2_entreprise::chiffre_affaires',
        nom_etape: 'etape_2_entreprise/chiffre_affaires',
        sollicitation: 0,
        num_etape: 2,
        page_erreur: 0,
    },
    YearsOfExperience: {
        xiti_xtpage: 'devis_pro::etape_2_entreprise::experience',
        nom_etape: 'etape_2_entreprise/experience',
        sollicitation: 0,
        num_etape: 2,
        page_erreur: 0,
    },
    CatalogRecommandation: {
        xiti_xtpage: 'devis_pro::etape_2_entreprise::recommandation_produits',
        nom_etape: 'etape_2_entreprise/recommandation_produits',
        sollicitation: 0,
        num_etape: 2,
        page_erreur: 0,
    },
    Contact: {
        xiti_xtpage: 'devis_pro::etape_3_coordonnees::coordonnees',
        nom_etape: 'etape_3_coordonnees/coordonnees',
        sollicitation: 0,
        num_etape: 3,
        page_erreur: 0,
    },
    ChooseAdvisor: {
        xiti_xtpage: 'devis_pro::etape_3_coordonnees::choix_agent',
        nom_etape: 'etape_3_coordonnees/choix_agent',
        sollicitation: 0,
        num_etape: 3,
        page_erreur: 0,
    },
    Error: {
        xiti_xtpage: 'devis_pro::etape_4_confirmation::ko::erreur_technique',
        nom_etape: 'etape_4_confirmation/ko/erreur_technique',
        sollicitation: 0,
        num_etape: 4,
        page_erreur: 1,
    },
    'End/Confirmation': {
        xiti_xtpage: 'devis_pro::etape_4_confirmation::ok::agent',
        nom_etape: 'etape_4_confirmation/ok/agent',
        sollicitation: 1,
        num_etape: 4,
        page_erreur: 0,
    },
    'End/AxaPartner': {
        xiti_xtpage: 'devis_pro::etape_4_confirmation::ok::axa_part',
        nom_etape: 'etape_4_confirmation/ok/axa_part',
        sollicitation: 1,
        num_etape: 4,
        page_erreur: 0,
    },
    'End/Reject': {
        xiti_xtpage: 'devis_pro::etape_4_confirmation::ko::rejet',
        nom_etape: 'etape_4_confirmation/ko/rejet',
        sollicitation: 0,
        num_etape: 4,
        page_erreur: 1,
        rejet: funnel ?? 'rejet',
    },
    'End/Unreliable-contact-information': {
        xiti_xtpage: 'devis_pro::etape_4_confirmation::ko::cnf',
        nom_etape: 'etape_4_confirmation/ko/cnf',
        sollicitation: 0,
        num_etape: 4,
        page_erreur: 1,
        rejet: 'cnf',
    },
    'End/Apart-from-metropolis': {
        xiti_xtpage: 'devis_pro::etape_4_confirmation::ko::dom_tom',
        nom_etape: 'etape_4_confirmation/ko/dom_tom',
        sollicitation: 0,
        num_etape: 4,
        page_erreur: 1,
        rejet: 'hors_metropole',
    },
    'End/Rejet-sec': {
        xiti_xtpage: 'devis_pro::etape_4_confirmation::ko::rejet',
        nom_etape: 'etape_4_confirmation/ko/rejet',
        sollicitation: 0,
        num_etape: 4,
        page_erreur: 1,
        rejet: 'rejet-sec',
    },
    'End/Rejet-vtc': {
        xiti_xtpage: 'devis_pro::etape_4_confirmation::ko::rejet',
        nom_etape: 'etape_4_confirmation/ko/rejet',
        sollicitation: 0,
        num_etape: 4,
        page_erreur: 1,
        rejet: 'rejet-vtc',
    },
    'End/Out-of-bounds': {
        xiti_xtpage: 'devis_pro::etape_4_confirmation::ko::hors_limite',
        nom_etape: 'etape_4_confirmation/ko/hors_limite',
        sollicitation: 0,
        num_etape: 4,
        page_erreur: 1,
        rejet: 'hors_limite',
    },
    'End/Insurance': {
        xiti_xtpage: 'devis_pro::etape_4_confirmation::ko::assurance',
        nom_etape: 'etape_4_confirmation/ko/assurance',
        sollicitation: 0,
        num_etape: 4,
        page_erreur: 1,
        rejet: 'assurance',
    },
    'End/Off-target-product': {
        xiti_xtpage: 'devis_pro::etape_4_confirmation::ko::hors_cible_produit',
        nom_etape: 'etape_4_confirmation/ko/hors_cible_produit',
        sollicitation: 0,
        num_etape: 4,
        page_erreur: 1,
        rejet: 'hors_cible_produit',
    },
    'End/Abort': null,
    HasEmployees: null,
    HasPeculiarities: null,
    CumulativeValueOfGoods: null,
    BusinessPremisesPresence: null,
    BusinessPremisesOwnership: null,
    BusinessPremisesSurface: null,
    Tarification: null,
    PreEconomicSector: null,
    PreChooseAdvisor: null,
    PreLegalStatus: null,
    PreConfirmation: null,
    PreCatalogRecommandation: null,
    PricingNeeds: null,
    PreTarification: null,
    Scenarios: null,
});

export const getMicroEntNavigationData = (funnel?: string): Record<NavigationPath, TagDataLayer | null> => ({
    Company: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_1_entreprise::siret',
        nom_etape: 'etape_1_entreprise/siret',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    EconomicSector: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_1_entreprise::secteur_activite',
        nom_etape: 'etape_1_entreprise/secteur_activite',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    LegalStatus: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_1_entreprise::forme_juridique',
        nom_etape: 'etape_1_entreprise/forme_juridique',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    HasEmployees: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_1_entreprise::salaries',
        nom_etape: 'etape_1_entreprise/salaries',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    Income: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_1_entreprise::chiffre_affaires_previsionnel',
        nom_etape: 'etape_1_entreprise/chiffre_affaires_previsionnel',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    HasPeculiarities: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_1_entreprise::specificites_activite',
        nom_etape: 'etape_1_entreprise/specificites_activite',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    CumulativeValueOfGoods: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_1_entreprise::valeur_materiel',
        nom_etape: 'etape_1_entreprise/valeur_materiel',
        sollicitation: 0,
        num_etape: 1,
        page_erreur: 0,
    },
    BusinessPremisesPresence: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_2_local::local_pro_dedie',
        nom_etape: 'etape_2_local/local_pro_dedie',
        sollicitation: 0,
        num_etape: 2,
        page_erreur: 0,
    },
    BusinessPremisesOwnership: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_2_local::locataire_proprietaire_local',
        nom_etape: 'etape_2_local/locataire_proprietaire_local',
        sollicitation: 0,
        num_etape: 2,
        page_erreur: 0,
    },
    BusinessPremisesSurface: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_2_local::superficie_local',
        nom_etape: 'etape_2_local/superficie_local',
        sollicitation: 0,
        num_etape: 2,
        page_erreur: 0,
    },
    Contact: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_3_coordonnees::coordonnees',
        nom_etape: 'etape_3_coordonnees/coordonnees',
        sollicitation: 0,
        num_etape: 3,
        page_erreur: 0,
    },
    Tarification: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_4_tarif::tarif',
        nom_etape: 'etape_4_tarif/tarif',
        sollicitation: 0,
        num_etape: 4,
        page_erreur: 0,
    },
    Error: {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_5_confirmation::ko::erreur_technique',
        nom_etape: 'etape_5_confirmation/ko/erreur_technique',
        sollicitation: 0,
        num_etape: 5,
        page_erreur: 1,
    },
    'End/Confirmation': {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_5_confirmation::ok::agent',
        nom_etape: 'etape_5_confirmation/ok/agent',
        sollicitation: 1,
        num_etape: 5,
        page_erreur: 0,
    },
    'End/AxaPartner': {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_5_confirmation::ko::axa_part',
        nom_etape: 'etape_5_confirmation/ko/axa_part',
        sollicitation: 1,
        num_etape: 5,
        page_erreur: 0,
    },
    'End/Reject': {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_5_confirmation::ko::rejet',
        nom_etape: 'etape_5_confirmation/ko/rejet',
        sollicitation: 0,
        num_etape: 5,
        page_erreur: 1,
        rejet: funnel ?? 'rejet',
    },
    'End/Apart-from-metropolis': {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_5_confirmation::ko::dom_tom',
        nom_etape: 'etape_5_confirmation/ko/dom_tom',
        sollicitation: 0,
        num_etape: 5,
        page_erreur: 1,
        rejet: 'dom_tom',
    },
    'End/Out-of-bounds': {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_5_confirmation::ko::hors_limite',
        nom_etape: 'etape_5_confirmation/ko/hors_limite',
        sollicitation: 0,
        num_etape: 5,
        page_erreur: 1,
        rejet: 'hors_limite',
    },
    'End/Off-target-product': {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_5_confirmation::ok::hors_cible_produit',
        nom_etape: 'etape_5_confirmation/ok/hors_cible_produit',
        sollicitation: 0,
        num_etape: 5,
        page_erreur: 1,
        rejet: 'hors_cible_produit',
    },
    'End/Unreliable-contact-information': {
        xiti_xtpage: 'quickquote_micro_entrepreneur::etape_5_confirmation::ko::cnf',
        nom_etape: 'etape_5_confirmation/ko/cnf',
        sollicitation: 0,
        num_etape: 5,
        page_erreur: 1,
        rejet: 'cnf',
    },
    RecommandationHome: null,
    Catalog: null,
    NumberOfEmployees: null,
    YearsOfExperience: null,
    CatalogRecommandation: null,
    ChooseAdvisor: null,
    'End/Rejet-sec': null,
    'End/Rejet-vtc': null,
    'End/Insurance': null,
    'End/Abort': null,
    PreEconomicSector: null,
    PreChooseAdvisor: null,
    PreLegalStatus: null,
    PreConfirmation: null,
    PreCatalogRecommandation: null,
    PricingNeeds: null,
    PreTarification: null,
    Scenarios: null,
});

export const NAVIGATION_DATA = getProEntNavigationData();
